import { toast } from "react-toastify";
import { AWSAppSyncClient } from "aws-appsync";

import { sentryWrappedException } from "~/utils/Utils";
import ParcisionCookies from "../../../utils/Cookies";
import "../../../configureAmplify";

export default function getClient() {
  try {
    // CREATE AWS APPSYNC CLIENT
    const aws_exports = require("../../../aws-exports").default;

    // CONFIG
    const AppSync = {
      graphqlEndpoint: aws_exports.aws_appsync_graphqlEndpoint,
      region: aws_exports.aws_appsync_region,
      authenticationType: aws_exports.aws_appsync_authenticationType,
      apiKey: aws_exports.aws_appsync_apiKey,
    };

    const AUTH_TYPE = require("aws-appsync-auth-link").AUTH_TYPE;

    // CREDENTIALS
    // if (cred === "web3") {
    //  userCredentials = {
    //    accessKeyId: ParcisionCookies.get("web3_accessKeyId"),
    //    secretAccessKey: ParcisionCookies.get("web3_secretAccessKey"),
    //    sessionToken: ParcisionCookies.get("web3_sessionToken"),
    //  };
    // } else {
    const userCredentials = {
      accessKeyId: ParcisionCookies.get("auth0_accessKeyId"),
      secretAccessKey: ParcisionCookies.get("auth0_secretAccessKey"),
      sessionToken: ParcisionCookies.get("auth0_sessionToken"),
    };
    // }

    // Set up AppSync client
    return new AWSAppSyncClient({
      url: AppSync.graphqlEndpoint,
      region: AppSync.region,
      auth: {
        type: AUTH_TYPE.AWS_IAM,
        apiKey: AppSync.apiKey,
        credentials: userCredentials,
      },
      disableOffline: true,
    });
  } catch (error) {
    sentryWrappedException(error);
    toast.error("Failed to get client");
    throw error;
  }
}
